// src/App.js — Route definitions
import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login        from './pages/Login'
import Dashboard    from './pages/Dashboard'
import Mandates     from './pages/BDPipeline'
import MandateDetail from './pages/MandateDetail'
import Contacts     from './pages/Contacts'
import Partners     from './pages/Partners'
import Firms        from './pages/Firms'
import Interactions from './pages/Interactions'
import Settings     from './pages/Settings'

function NotFound() {
  return (
    <div className="page">
      <div className="empty-state" style={{ paddingTop: '80px' }}>
        <h3>Page not found</h3>
        <p>The page you're looking for doesn't exist.</p>
      </div>
    </div>
  )
}

function ProtectedApp() {
  return (
    <Layout>
      <Routes>
        <Route path="/"               element={<Dashboard />} />
        <Route path="/mandates"       element={<Mandates />} />
        <Route path="/mandates/:id"   element={<MandateDetail />} />
        <Route path="/contacts"       element={<Contacts />} />
        <Route path="/partners"       element={<Partners />} />
        <Route path="/firms"          element={<Firms />} />
        <Route path="/interactions"   element={<Interactions />} />
        <Route path="/settings"       element={<Settings />} />
        <Route path="*"               element={<NotFound />} />
      </Routes>
    </Layout>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <ProtectedApp />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}
